import { render, staticRenderFns } from "./liveBroDetail.vue?vue&type=template&id=12de30d4&scoped=true"
import script from "./liveBroDetail.vue?vue&type=script&lang=js"
export * from "./liveBroDetail.vue?vue&type=script&lang=js"
import style0 from "./liveBroDetail.vue?vue&type=style&index=0&id=12de30d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12de30d4",
  null
  
)

export default component.exports